import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { regexList } from '@shared/constants/regex-list';
import { Group } from '@shared/models/group';
import { Session } from '@shared/models/session';
import { GroupsService } from '@shared/services/groups.service';
import { SessionService } from '@shared/services/session.service';
import { LoadingState } from '@shared/types/loading-state';
import { Observable, skipWhile, take } from 'rxjs';

@Component({
  selector: 'app-send-agreement-for-signatures',
  templateUrl: './send-agreement-for-signatures.component.html',
  styleUrls: ['./send-agreement-for-signatures.component.scss'],
  standalone: false,
})
export class SendAgreementForSignaturesComponent implements OnInit {
  @Input() groupId: string;
  group$: Observable<Group | undefined>;
  session$: Observable<Session | undefined>;
  loadingState$: Observable<LoadingState>;
  sendAgreementForSignaturesForm: FormGroup = new FormGroup({
    confirmSignatoryEmail: new FormControl(false, Validators.requiredTrue),
    email: new FormControl('', [Validators.required, Validators.pattern(regexList.is_email)]),
  });

  constructor(
    private modalController: ModalController,
    private groupsService: GroupsService,
    private sessionService: SessionService,
  ) {}

  ngOnInit(): void {
    this.loadingState$ = this.groupsService.getGroupsLoading();
    this.session$ = this.sessionService.getSession();
    this.group$ = this.groupsService.getGroup(this.groupId);
    this.sessionService
      .getSession()
      .pipe(take(1))
      .subscribe((session) => {
        if (!session?.mfa_setting?.enforced || (session?.mfa_setting?.enforced && session?.mfa_setting?.active)) {
          this.group$.pipe(take(1)).subscribe((group) => {
            if (!group) {
              this.groupsService.loadGroup(this.groupId!);
            }
          });
          this.group$.pipe(skipWhile((group) => !group)).subscribe((group) => {
            if (!!group) {
              const strategicContact = group.attributes?.contacts?.find((contact) =>
                contact.contact_roles?.some((role) => role === 'strategic'),
              );
              const primaryContact = group.attributes?.contacts?.find((contact) =>
                contact.contact_roles?.some((role) => role === 'primary'),
              );
              this.sendAgreementForSignaturesForm.patchValue({
                email: strategicContact?.email || primaryContact?.email || '',
              });
            }
          });
        }
      });
  }

  closeModal(): void {
    this.modalController.dismiss();
  }

  sendAgreementForSignatures(): void {
    if (this.sendAgreementForSignaturesForm.valid) {
      this.groupsService.sendAgreementForSignatures(this.groupId, this.sendAgreementForSignaturesForm.value.email);
    }
  }
}
